import { InvoiceGateway } from "../domain/invoice.gateway";
import { InvoicesInterface } from "../domain/invoice.entities";
import { InvoiceInterface } from "../domain/invoice.entities";

export class CreateUseCase {
    constructor(private gate: InvoiceGateway) {}

    async execute(params: InvoiceInterface[], text: string, amount: number, amount_liquid: number, count: number): Promise<any> {
        const updatedParams: InvoicesInterface = {
            invoices: params,
            text: text,
            amount: amount,
            amount_liquid: amount_liquid,
            count: count
        }
        return this.gate.create(updatedParams);
    }
}
